module.exports = __webpack_public_path__ + "img/pop_img.c7ccf8f3.png";